import { render, staticRenderFns } from "./InClass.vue?vue&type=template&id=469c9078&scoped=true&"
import script from "./InClass.vue?vue&type=script&lang=js&"
export * from "./InClass.vue?vue&type=script&lang=js&"
import style0 from "./InClass.vue?vue&type=style&index=0&id=469c9078&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469c9078",
  null
  
)

export default component.exports